import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CustomIcon from "../components/CustomIcon";
import CustomImage from "../components/CustomImage";
import CustomInput from "../components/CustomInput";
import CustomSelect from "../components/CustomSelect";
import NavBar from "../components/Navigation/NavBar";
import SubscribeNotification from "../components/SubscribeNotification";
import { listCategoryAction } from "../redux/slices/categoriesSlice";
import { getProfileAction } from "../redux/slices/profilesSlice";
import {CHANGE_ADDRESS_PATH, CHANGE_IMAGE_PATH, CHANGE_PASSWORD_PATH, CHANGE_SERVICE_PATH, DELETE_ACCOUNT_PATH, SUBSCRIPTION_PATH } from "../utility/path";
import H from "../components/H";
import { getConstant, handleErrorResponse, handleHeader } from "../services/functions";
import { verifyMobileAction } from "../redux/slices/authSlice";
import CustomTooltip from "../components/CustomTooltip";
import "../profile.css"
import { StimingData, EtimingData } from "../utility/timingUtils";
import BottomNav from "../components/Navigation/BottomNav";

const Profile = ({}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authData = useSelector(state => state?.auth?.data);
  const profile = useSelector(state => state?.profile);
  const categoriesData = useSelector(state => state?.categories?.data);
  const [isCategoryUser, setIsCategoryUser] = useState(false);
  const [toggle,setToggle] = useState(profile?.data?.category?.length ? true : false);
  
  

  const [showTransition,setShowTransition] = useState(false);
  useEffect(() => {
    handleHeader({...getConstant("PROFILE")},dispatch);
    setShowTransition(true);
    dispatch(getProfileAction(authData))
    dispatch(listCategoryAction(authData));
    setToggle(()=>{return profile?.data?.category?.length ? true : false});
    
    return ()=>{}

  }, []);

  useEffect(() => {
    if (categoriesData) {
      const isUserCategory = categoriesData.some(c => c.name === 'user' && profile?.data?.category?.length > 0 && profile?.data?.category?.[0] === c.id);
      setIsCategoryUser(isUserCategory);
    }
  }, [categoriesData, profile?.data?.category]);

  // handle field change
  const handleChange = input => e => {
    e.preventDefault();
  }

  const getBase64 = file => {
    return new Promise(resolve => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        console.log("Called", reader);
        baseURL = reader.result;
        console.log(baseURL);
        resolve(baseURL);
      };
      console.log(fileInfo);
    });
  };

  const handleClickAddress = (event) =>{
    event.preventDefault();
    //dispatch(updateProfileAddressAction(state));
    navigate(CHANGE_ADDRESS_PATH,{state:{address:profile?.data?.address,pincode:profile?.data?.pincode,id:profile?.data?.id}});
    
  }

  const handleClickChangePassword = (event) =>{
    event.preventDefault();
    //dispatch(updateProfileAddressAction(state));
    navigate(CHANGE_PASSWORD_PATH,{state:{id:profile?.data?.id}});
  }

  const handleClickChangeImage = (event) =>{
    event.preventDefault();
    //dispatch(updateProfileAddressAction(state));
    navigate(CHANGE_IMAGE_PATH,{state:{image:profile?.data?.profilePhoto,id:profile?.data?.id}});
  }

  const handleClickChangeService = (event) =>{
    event.preventDefault();

    //start 
    //allowing user to change category
    // if(isCategoryUser){
    //   handleErrorResponse({message:'Operation not allowed[001]!!'},dispatch)
    // }
    //end

    //dispatch(updateProfileAddressAction(state));
    navigate(CHANGE_SERVICE_PATH,{state:{id:profile?.data?.id,category:profile?.data?.category,fee:profile?.data?.fee,categoriesData:categoriesData,aboutme:profile?.data?.aboutme,instalink:profile?.data?.instalink,fblink:profile?.data?.fblink,startTime:profile?.data?.startTime,endTime:profile?.data?.endTime}});
  }
  
  const renderForm = () =>{
    return (
      <>
      {/* avatar */}
        <div className="profile-avatar-wrap p-1 mb-2">
          <CustomImage state = {{image:profile?.data?.profilePhoto,name:profile?.data?.name}} className="profile-avatar" size={"5rem"}/>
          <div className="profile-avatar-edit" onClick={(e)=>handleClickChangeImage(e)}>
            <i className="fa fa-pencil" />
          </div>
        </div>

        {profile?.data?.toggleProvider && 
        <div className="p-1 mb-2">
          {profile?.data?.subscribed && <small className="uic-badge">Account status: Active</small>}
          {!profile?.data?.subscribed && <small role="button" className="caution p-1 rounded cursor" onClick={(e)=> {e.preventDefault; navigate(SUBSCRIPTION_PATH)}}>Account status: Inactive</small> }
        </div>}
        
        {/* Personal Info */}
        <div className="profile-section">
          <p className="profile-section__header">Personal Info</p>

          <CustomInput title="" id="nameId" type="text" placeholder="Your name" handleChange={handleChange} name="name" value={profile?.data?.name || ''} isDisable={true} addCssToInput="capitalize" />
          <CustomInput title="" id="mobileId" type="text" placeholder="Your mobile" handleChange={handleChange} name="mobile" value={profile?.data?.mobile || ''} isDisable={true} />
          <CustomInput title="" id="oldPasswordId" type="password" placeholder="Password" handleChange={handleChange} name="oldPassword" isDisable={true} value="******" />

          <div className="profile-section__footer">
            <button className="profile-edit-btn" onClick={(e)=>handleClickChangePassword(e)}>
              <CustomIcon type="pencil-square"/> Edit Password
            </button>
          </div>
        </div>

        {/* Address */}
        {profile?.data?.toggleProvider && (<div className="profile-section">
          <p className="profile-section__header">Address</p>
          <CustomInput title="" id="addressId" type="text" placeholder="Your address" handleChange={handleChange} name="address" value={profile?.data?.address || ''} isDisable={true} addCssToInput="capitalize" />
          <CustomInput title="" id="pincodeId" type="number" placeholder="Your pincode" handleChange={handleChange} name="pincode" value={profile?.data?.pincode || ''} isDisable={true} />

          <div className="profile-section__footer">
            <button type="button" className="profile-edit-btn" onClick={(e) => { handleClickAddress(e) }}>
              Edit Address <CustomIcon type="pencil-square" />
            </button>  
          </div>
        </div>)}

        {/* {!isCategoryUser ? (<div className="bg-light border border-light rounded p-1 mb-2">
          {!profile?.data?.category?.length ? (<div className="form-check form-switch mb-3">
            <input className="form-check-input"
              type="checkbox" role="switch" id="flexSwitchCheckChecked"
              checked={toggle}
              onChange={() => setToggle(!toggle)} />
            <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Join as a <b>{!toggle ? 'Professional?' : 'User?'}</b></label>
          </div>) : ''}
          {toggle || profile?.data?.category?.length
            ? (<>
              <CustomSelect title="Category " handleChange={handleChange} name="category" defaultOptionValue="Select category" data={categoriesData} state={{ category: profile?.data?.category || '' }} isDisable={true} tooltipInfo={"Note: Category cannot be changed once created!!"} /> */}

              {/* <CustomInput title="Approx service fee*" id="feeId" type="number" placeholder="&emsp;&emsp;&emsp;&emsp;Service charge*" handleChange={handleChange} name="fee" value={profile?.data?.fee} isDisable={true} preInputText="INR"/> */}

              {/* {profile?.data?.aboutme ? <div className="form-floating mb-3"><H value="About me"></H><p className="disabled-bg-color p-2 rounded capitalize-first">{profile?.data?.aboutme}</p></div> : ''}

              <button type="button" className="btn btn-outline-primary mb-3" onClick={(e) => handleClickChangeService(e)}>
                Edit Service <CustomIcon type="pencil-square" />
              </button>
            </>)
            : ''}
        </div>) : ''} */}

        {/* Professional Details */}
        <div className="profile-section">
          <p className="profile-section__header">Professional Details</p>

          <CustomSelect title="Your Professional Category!" handleChange={handleChange} name="category" defaultOptionValue="Select category" data={categoriesData} state={{ category: profile?.data?.category || '' }} isDisable={true} tooltipInfo={""} />

          {/* <CustomInput title="Approx service fee*" id="feeId" type="number" placeholder="&emsp;&emsp;&emsp;&emsp;Service charge*" handleChange={handleChange} name="fee" value={profile?.data?.fee} isDisable={true} preInputText="INR"/> */}

          {!isCategoryUser &&
            <div className="form-floating mb-3">
              <textarea id="aboutmeId" type="text" rows={3} className="form-control form-floating bg-light" style={{paddingTop:'1.5rem'}} placeholder="About me" disabled={true} autoComplete="off" defaultValue={profile?.data?.aboutme || ""}></textarea>
              <label htmlFor="aboutmeId">About me</label>
            </div>
          }

          {!isCategoryUser &&
            <CustomSelect title="Starting time ⏰" handleChange={handleChange} name="startTime" defaultOptionValue="Select start time" data={StimingData} state={{ startTime: profile?.data?.startTime || '' }} isDisable={true} tooltipInfo={""} />
          }

          {!isCategoryUser &&
            <CustomSelect title="Closing Time ⏰" handleChange={handleChange} name="endTime" defaultOptionValue="Select end time" data={EtimingData} state={{ endTime: profile?.data?.endTime || '' }} isDisable={true} tooltipInfo={""} />
          }

          {!isCategoryUser && <div className="profile-field" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div className="profile-social-icon profile-social-icon--insta">
              <i className="fa fa-instagram" />
            </div>
            <p className="profile-field__value">{profile?.data?.instalink || "Instagram link"}</p>
          </div>}

          {!isCategoryUser && <div className="profile-field" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div className="profile-social-icon profile-social-icon--fb">
              <i className="fa fa-facebook" />
            </div>
            <p className="profile-field__value">{profile?.data?.fblink || "Facebook link"}</p>
          </div>}

          <div className="profile-section__footer">
            <button type="button" className="profile-edit-btn" onClick={(e) => handleClickChangeService(e)}>
              Edit Details <CustomIcon type="pencil-square" />
            </button>
          </div>

        </div>
        
        <div className="profile-section">
          <p className="profile-section__header">Manage Account</p>
          {profile?.data?.notificationEnabled != undefined && profile?.data.notificationEnabled != "undefined"  && (
            <SubscribeNotification notificationEnabled={profile?.data.notificationEnabled}/>
          )}

          <div className="profile-action-row">
            <div className="profile-action-row__icon profile-action-row__icon--danger">
              <i className="fa fa-trash" />
            </div>
            <div className="profile-action-row__text">
              <p className="profile-action-row__title">Delete Account <CustomTooltip tooltipInfo={"Account deletion is permanent and cannot be recovered!!"}/></p>
              <p className="profile-action-row__sub">This action is irreversible</p>
            </div>
            <button className="profile-delete-btn" onClick={(e)=>{e.preventDefault; dispatch(verifyMobileAction({id:profile?.data?.id,locationPathname:location?.pathname,action:'delete_account'})); navigate(DELETE_ACCOUNT_PATH,{state:{id:profile?.data?.id}});}}>Delete</button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
    <NavBar/>
    <div className={`main-container bn-page-offset show-transition ${showTransition ? "show" : ""}`}>
      <div className="row">
        <div className="col-md-6 offset-md-3">
          {!profile?.loading && !profile?.appErr && !profile?.serverErr ? (renderForm()) : ''}
          {!profile?.loading && (profile?.appErr || profile?.serverErr) ? (<div>Error, please try again later!!</div>) : ''}
        </div>
      </div>
    </div>
    <BottomNav/>
    </>
  );
}

export default Profile;
